// extracted by mini-css-extract-plugin
export var layoutContainer = "_dh-0";
export var layoutContainerNoRounding = "_dh-6";
export var layoutContainerOpen = "_dh-5";
export var layoutContainerResizing = "_dh-1";
export var mainContent = "_dh-2";
export var resizeDivider = "_dh-3";
export var slidePanel = "_dh-4";